module.exports = __webpack_public_path__ + "img/jk1.6ba86ce0.jpg";